import React, { memo } from 'react';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { PlaceholderIcon } from '@icarius-icons';
import { renderHighlightedText } from './utils';

const properties = require("@icarius-utils/properties");

const CommandPaletteRow = memo(({ result, index, selectedIndex, handleSelect, setSelectedIndex, classes, isDark }) => {
  const { item, matches } = result;

  return (
    <ListItem
      button
      component="div"
      selected={index === selectedIndex}
      className={`${classes.listItem} ${classes.listItemRow}`}
      onClick={() => handleSelect(item)}
      onMouseEnter={() => setSelectedIndex(index)}
    >
      <ListItemIcon className={classes.listItemIcon}>
        {item.icon ? item.icon : <PlaceholderIcon />}
      </ListItemIcon>
      <ListItemText
        className={classes.listItemTextContainer}
        primary={
          <Typography variant="body1">
            {renderHighlightedText(item.label, matches, classes.matchHighlight, isDark, 'label')}
            {properties['SEARCH_BY_PATH'] === true && item.path && (
              <span style={{ marginLeft: 8, color: isDark ? '#888' : '#aaa' }}>
                ({renderHighlightedText(item.path, matches, classes.matchHighlight, isDark, 'path')})
              </span>
            )}
          </Typography>
        }
      />
    </ListItem>
  );
});

export default CommandPaletteRow;
